import * as Sentry from "@sentry/astro";

Sentry.init({
    dsn: "https://e6c05ff44a167ca2606a8e89bccb8bcd@o4511785093234688.ingest.de.sentry.io/4511785126002768",
    ignoreErrors: [
        // View transitions aborted by user navigation / viewport changes / DOM update timeout
        /Transition was aborted/i,
        /View transition was skipped/i,
        /Skipping view transition/i,
        /TimeoutError.*transition/i,
        /InvalidStateError.*transition/i,

        // Browser extension / Web extension messaging errors
        /Invalid call to runtime\.sendMessage/i,

        // In-App Browser (Facebook/Instagram/Meta) Android webview lifecycle error
        /Java object is gone/i,
        /Error invoking postMessage/i,
        /postMessage.*Java object is gone/i,

        // DuckDuckGo / third-party in-page messaging origin checks
        /invalid origin/i,

        // Google Merchant / third-party widget errors
        /Cannot read properties of undefined \(reading 'supports'\)/i,

        // ResizeObserver browser loop noise
        /ResizeObserver loop/i,

        // Maximum call stack size exceeded from third-party scripts / GTM recursion / browser translation
        /Maximum call stack size exceeded/i,
        /too much recursion/i,

        // Non-actionable minified unhandled rejections from third-party scripts
        /^Error: La$/i,
    ],
    denyUrls: [
        // Facebook/Instagram In-App Browser injected bridge scripts
        /iabjs:\/\//i,
        /navigation_performance_logger_android/i,
        // Browser extensions
        /^chrome-extension:\/\//i,
        /^moz-extension:\/\//i,
        /^safari-extension:\/\//i,
        /^safari-web-extension:\/\//i,
    ],
    beforeSend(event, hint) {
        const error = hint?.originalException;
        const msg = (
            event?.message ||
            (event?.exception?.values && event.exception.values[0]?.value) ||
            (error instanceof Error ? error.message : '') ||
            String(error || '')
        ).toLowerCase();

        // Drop Maximum call stack size exceeded noise
        if (
            msg.includes('maximum call stack size exceeded') ||
            msg.includes('too much recursion')
        ) {
            return null;
        }

        // Drop View Transitions timeout/abort noise
        if (
            msg.includes('transition was aborted') ||
            msg.includes('skipping view transition') ||
            msg.includes('view transition was skipped')
        ) {
            return null;
        }

        // Drop In-App Browser bridge lifecycle errors (Facebook / Meta Android WebView)
        if (
            msg.includes('java object is gone') ||
            msg.includes('postmessage: java object is gone')
        ) {
            return null;
        }

        // Drop errors originating from in-app browser scripts or browser extensions
        const frames = event?.exception?.values?.flatMap(v => v?.stacktrace?.frames || []) || [];
        const hasDeniedFrame = frames.some(f => {
            const file = (f?.filename || '').toLowerCase();
            return (
                file.includes('iabjs://') ||
                file.includes('navigation_performance_logger') ||
                file.startsWith('chrome-extension://') ||
                file.startsWith('moz-extension://') ||
                file.startsWith('safari-extension://') ||
                file.startsWith('safari-web-extension://')
            );
        });

        if (hasDeniedFrame) {
            return null;
        }

        return event;
    },
    dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#dataCollection
        // userInfo: false,
        // httpBodies: [],
    },
});